import { IStyle, getTheme, mergeStyleSets } from "@fluentui/react";

export const internal__getImageBrowserPartStyles = (cartridgeWidth: number) => {
  const theme = getTheme();

  const cartridge: IStyle = {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    top: 0,
    height: '100%',
    width: cartridgeWidth,
  };
  
  const glassCover: IStyle = {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
  };
  
  const nav: IStyle = {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  };
  
  const navSpacer: IStyle = {
    flexGrow: 1,
  };
  
  const indexIndicatorContainer: IStyle = {
    position: 'absolute',
    bottom: 15,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  };
  
  const indexIndicatorPanel: IStyle = {
    position: 'absolute',
    bottom: 15,
    display: 'flex',
    flexDirection: 'row',
    gap: 6,
  };
  
  const indexIndicatorPassive: IStyle = {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.white,
    opacity: 0.45,
  };
  
  const indexIndicatorActive: IStyle = {
    ...indexIndicatorPassive,
    backgroundColor: theme.palette.themePrimary,
    opacity: 1,
  };
  
  const likeIndicator: IStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display: 'none',
    userSelect: 'none',
  };
  
  const showLikeIndicator: IStyle = {
    display: 'inline-block !important',
  };
  
  const likeIndicatorIcon: IStyle = {
    marginLeft: '-50%',
    marginTop: '-50%',
    fontSize: 220,
    color: theme.palette.white,
    userSelect: 'none',
    opacity: 1,
  };
  
  const contextButton: IStyle = {
    position: 'absolute',
    top: 0,
    right: 0,
    display: 'inline-block',
    padding: 15,
    color: theme.palette.white,
    fontSize: 24,
    cursor: 'pointer',

    '&:hover': {
      color: theme.palette.themePrimary,
    },
  };

  return mergeStyleSets({
    cartridge,
    glassCover,
    nav,
    navSpacer,
    indexIndicatorContainer,
    indexIndicatorPanel,
    indexIndicatorPassive,
    indexIndicatorActive,
    likeIndicator,
    showLikeIndicator,
    likeIndicatorIcon,
    contextButton,
  });
}

export const internal__getImageBrowserRootStyle = (imageWidth: number, imageHeight: number) => {

  const root: IStyle = {
    position: 'relative',
    width: imageWidth,
    height: imageHeight,
    overflow: 'hidden',
  };
  
  return [root];
}